import { getDeviceFingerprint } from "./functions";

/**
 * Represents the context that is sent when a mutation context is used. If an authentication error is returned the logout state will be set to 'true'.
 *
 * @param wt {Object} jwt
 * @param setLogoutFlag {useState} = boolean state for logout state from react.useState
  */
function sendMutationContext(wt, setLogoutFlag) {
  return {
    context: {
      headers: {
        authorization: wt && wt.wt ? `Bearer ${wt.wt}` : '', // Include the token in the request header
        'X-Device-Fingerprint': getDeviceFingerprint(), // Include the device fingerprint in a custom header
      },
    },
    onError: (errors) => {
      if (errors.networkError) {
        const serverError = errors.networkError.result.errors[0].message;
        if (serverError === "Authentication required.") {
          setLogoutFlag(true);
        }
      }
    }
  };
}

export default sendMutationContext;